import { ColorInputHex } from '@dtx-company/shared-components/src/components/molecules/ColorInputHex'
import { ColorLensOutlined } from '@mui/icons-material'
import { EditTheme } from './types'
import { FC } from 'react'
import { LockedFeatureWrapper } from '@dtx-company/app/shared/common/src/components/LockedFeatureWrapper/LockedFeatureWrapper'
import { Stack, Typography } from '@dtx-company/design-system/src'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useCurrentPagePermissions } from '../../../utils/useGetCurrentPagePermissions'
import events from '@dtx-company/inter-app/src/event-tracking/events/flowpage'

interface FontStylePickerProps {
  linkColor?: string | null
  handleChange: (values: EditTheme) => void
  shadowColor?: string | null
  isInsetTheme?: boolean
  borderColor?: string | null
  disabled?: boolean
}
const LinkColorOptions: FC<FontStylePickerProps> = ({
  handleChange,
  shadowColor,
  linkColor,
  borderColor,
  disabled = false,
  isInsetTheme
}) => {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <ColorInputHex
        label="Link Color"
        disabled={disabled}
        color={linkColor ?? ''}
        onColorChange={color => {
          events.Flowpage_PageProfile_Selected_Page_Level_Link_Color(color)
          handleChange({ linkColor: color })
        }}
        width={{ _: '50%', md: '144px' }}
      />
      {isInsetTheme ? (
        <ColorInputHex
          label="Shadow Color"
          disabled={disabled}
          color={shadowColor ?? ''}
          onColorChange={color => {
            events.Flowpage_PageProfile_Selected_Page_Level_Shadow_Color(color)
            handleChange({ shadowColor: color })
          }}
          width={{ _: '50%', md: '144px' }}
        />
      ) : (
        <ColorInputHex
          label="Border Color"
          disabled={disabled}
          color={borderColor ?? ''}
          onColorChange={color => {
            events.Flowpage_PageProfile_Selected_Page_Level_Border_Color(color)
            handleChange({ borderColor: color })
          }}
          width={{ _: '50%', md: '144px' }}
        />
      )}
    </Stack>
  )
}

export const LinkColorPicker: FC<FontStylePickerProps> = props => {
  const { hasOperation } = useAuthState()
  const { hasViewOnlyAccess } = useCurrentPagePermissions()
  const userCanViewLinkColorOptions = hasOperation('view:page_style_options')
  return (
    <>
      <Stack
        sx={{
          mb: { xs: 2, lg: 4 },
          opacity: props.disabled ? 0.35 : 1
        }}
        direction="row"
        alignItems="center"
        spacing={{ md: 2 }}
      >
        <ColorLensOutlined sx={{ display: { xs: 'none', md: 'flex', fontSize: 16 } }} />
        <Typography variant={{ xs: 'bodyMedium', md: 'subtitleSmall' }}>
          Choose a link color
        </Typography>
      </Stack>
      {userCanViewLinkColorOptions ? (
        <LinkColorOptions {...props} disabled={hasViewOnlyAccess || props.disabled} />
      ) : (
        <LockedFeatureWrapper
          featureName="view:page_style_options"
          onOpen={() => {
            events.Flowpage_PageProfile_Clicked_Page_Level_Link_Colors_Lock()
          }}
        >
          <Stack sx={{ mb: 5 }}>
            <LinkColorOptions {...{ ...props, disabled: true }} />
          </Stack>
        </LockedFeatureWrapper>
      )}
    </>
  )
}
